import { render, staticRenderFns } from "./ReviewItemHtml.vue?vue&type=template&id=fc8291a8"
import script from "./ReviewItemHtml.vue?vue&type=script&lang=ts"
export * from "./ReviewItemHtml.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports